module.exports = (domain) => {
    if (process.env.NODE_ENV === "production") {
        return domain.includes("agence-immobilier.be") || domain.includes("agenceimmobilier.be") ? "fr" : "nl"
    } else {
        return "fr"; // just change to fr to test FR translations
    }
}
